export default __webpack_public_path__ + "static/media/logo-dark.9067e1de.svg";